<div id="container">
  <span>
    <nv-button *ngFor="let button of toolbarButtons" 
      icon="{{ button.icon }}" 
      size="{{ button.size }}" 
      type="{{ button.type }}" 
      (click)="button.action()"
    >
      {{ button.name }}
    </nv-button>
  </span>
</div>